import styles from './UnsavedChangesModal.module.css';

interface UnsavedChangesModalProps {
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
}

export default function UnsavedChangesModal({ onSave, onDiscard, onCancel }: UnsavedChangesModalProps) {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <h2>Ungespeicherte Änderungen</h2>
        <p>Du hast ungespeicherte Änderungen.</p>
        <p>Möchtest du sie speichern?</p>
        <div className={styles.buttonContainer}>
          <button onClick={onSave} className={styles.saveButton}>
            Speichern und fortfahren
          </button>
          <button onClick={onDiscard} className={styles.discardButton}>
            Verwerfen
          </button>
          <button onClick={onCancel} className={styles.cancelButton}>
            Zurück
          </button>
        </div>
      </div>
    </div>
  );
}
